<mat-toolbar
	layout="row"
	layout-align="start center"
	color="primary"
	class="sdp-header"
>
	<h3>
		<button
			mat-button
			routerLink="/administration/home"
			class="sdp-header-light-color sdp-header-logo-button"
		>{{ "application.title" | translate }}</button>
	</h3>
	<div
		class="sdp-right-side-container"
		*ngIf="isLoggedIn"
	>
		<span class="sdp-right-side-username">{{ user ? user.email : "" }}</span>
		<div class="sdp-header-nav-dropdown">
			<button
				mat-icon-button
				[matMenuTriggerFor]="menu"
			>
				<sdp-icon [icon]="vertIcon"></sdp-icon>
			</button>
			<mat-menu
				#menu="matMenu"
				class="sdp-header-menu"
			>
				<button
					mat-menu-item
					(click)="deleteAccount()"
					*ngIf="user && user.primary"
					class="warning-background"
				>
					<span>{{ "header.item.deleteAccount" | translate }}</span>
				</button>
				<button
					mat-menu-item
					(click)="goTo('wizard/home')"
					*ngIf="user && user.admin && isNotWizard"
				>
					<span>{{ "dashboard.wizard" | translate }}</span>
				</button>
				<button
					mat-menu-item
					(click)="goToUserSettings()"
				>
					<span>{{ "header.item.settings" | translate }}</span>
				</button>
				<a
					target="_blank"
					href="https://impulsepoint.atlassian.net/wiki/spaces/CMKB/pages/373784577/THIRD-PARTY+SOFTWARE+UTILIZED+BY+AND+IN+IMPULSE+S+SAFECONNECT+SDP"
					mat-menu-item
				>
					<span>{{ "header.item.attribution" | translate }}</span>
				</a>
				<button
					mat-menu-item
					(click)="logout()"
				>
					<span>{{ "header.item.signOut" | translate }}</span>
				</button>
			</mat-menu>
		</div>
	</div>
</mat-toolbar>